<template>
	<section>
		<TheBox title="Passwort setzen" :titleLevel="1">
			<p>
				{{ texts.formErrors.pwInvalid }}
			</p>
			<PasswordSetForm :token="token" :action="action" :newEmail="newEmail" :email="email" :userId="id" />
		</TheBox>
	</section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import PasswordSetForm from '@/components/forms/PasswordSetForm.vue';
import TheBox from '../components/TheBox.vue';
import { texts } from '../utils/texts';

export default defineComponent({
	name: 'PasswortSetzen',
	data() {
		return {};
	},
	components: {
		PasswordSetForm,
		TheBox,
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	computed: {
		token() {
			return this.$route.query.code as string;
		},
		action() {
			return this.$route.query.action as string;
		},
		newEmail() {
			//? Kann fürs erste ignoriert werden
			return this.$route.query.newEmail as string;
		},
		email() {
			return this.$route.query.email as string;
		},
		texts() {
			return texts;
		},
	},
	methods: {},
	mounted() {},
});
</script>
